/* eslint-disable import/prefer-default-export */
export const SET_DATE_RANGE = "SET_DATE_RANGE";
